<template>
  <el-dialog class="payDialog" width="320px" top="25vh" title="选择支付方式" :visible.sync="paytypeVisibles"
    @closed="payClosed" append-to-body :close-on-click-modal="false" :modal-append-to-body="true">
    <div class="payBtn_box" v-if="payDisable == false">
      <div style="">
        <img src="../../assets/wechat.png" style="margin-right: 10px;width: 60px;height: 60px" alt=""
          @click="GetViasPay('W01', cashAmount)">
        <img src="../../assets/alipay.png" style="margin-right: 10px;width: 60px;height: 60px" alt=""
          @click="GetViasPay('A01', cashAmount)">
      </div>

      <br />
      <p>请选择您的支付方式</p>
    </div>
    <div class="QrCode_box" v-if="payDisable == true">
      <div id="qrcode2" class="qrcode" ref="qrCodeUrl" v-loading="qrcodeLiading"></div>
      <p>{{ payPrompt }}</p>
    </div>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";
  export default {
    name: 'paydialog',
    props: {
      paytypeVisible: {
        type: Boolean,
      },
      /**
       * 金额
       */
      cashAmount: {
        type: Number,
      },
      /**
       * 订单ID
       */
      orderId: {
        type: String,
      },
      /**
       * type 1 订单支付 2 保险 3 充值
       */
      paytype: {
        type: Number,
      }
    },
    data() {
      return {
        paytypeVisibles: false,
        payDisable: false,
        payPrompt: '',
        qrcodeLiading: false,
        trxid: '',
        isQuery: false,
        timer: null,
        qrcodeobj: null,
        exec: null,
        orderQuery: null,
      }
    },

    watch: {
      paytypeVisible(newVal) {
        this.paytypeVisibles = newVal
      },
    },

    methods: {
      async GetViasPay(paytype, num) {

        if (this.paytype == 1) {
          this.exec = this.$api.GetViasPay
          this.orderQuery = this.$api.PayQuery
        } else if (this.paytype == 2) {
          this.exec = this.$api.GetInsurancePay
          this.orderQuery = this.$api.PayQuery
        } else if (this.paytype == 3) {
          this.exec = this.$api.GetRechargePay
          this.orderQuery = this.$api.RechargeQuery
        } else {
          this.exec = this.$api.GetViasPay
          this.orderQuery = this.$api.PayQuery
        }
        // 获取充值链接
        this.qrcodeLiading = true;
        this.payDisable = !this.payDisable;
        let params = {
          paytype: paytype,
          proId: this.orderId
        };
        params.money = num;
        if (paytype == "W01") {
          this.payPrompt = "请使用手机微信扫描上方二维码进行支付";
        } else if (paytype == "A01") {
          this.payPrompt = "请使用手机支付宝扫描上方二维码进行支付";
        }
        debugger
        var res = await this.exec(params)
        let {
          status,
          data
        } = res.data;
        if (status == 200) {
          // this.$message.success('保存供应商付款成功');
          // this.$route.go(0);
          console.log(data)
          this.trxid = data.trxid;
          const dom = document.getElementById('qrcode2')
          if (dom) dom.innerHTML = ''
          this.$nextTick(function () {
            this.qrcode(data.payurl, 2);
            this.qrcodeLiading = false;
            this.isQuery = true;
            this.timer = setInterval(this.PayQuery, 3000);
          });
        } else {
          this.$message.error('获取付款码失败');
        }
      },
      qrcode(link, num) {
        // 生成支付二维码
        let that = this;
        this.qrcodeobj = new QRCode("qrcode" + num, {
          width: 124,
          height: 124, // 高度
          text: link // 二维码内容
          // render: 'canvas' , // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          // background: '#f0f', // 背景色
          // foreground: '#ff0' // 前景色
        });
        // debugger;
      },
      async PayQuery() {
        // 查询充值结果
        let params = {
          trxid: this.trxid
        };
        var res = await this.orderQuery(params)
        // console.log(res, '保存供应商付款',this.amountFormdata.extend);
        let {
          status,
          data
        } = res;
        if (status == 200) {
          console.log(data, "查询交易结果");
          if (data.message == "支付成功") {
            this.isQuery = false;
            clearInterval(this.timer);
            this.$message.success("支付成功，感谢您的支持!");
            this.paytypeVisible1 = false;
            this.paytypeVisible2 = false;

            this.cashVisible = false;
            this.virtualVisible = false;
            this.$emit("onClosed");
            console.log(this.paytype)
            this.$emit("payBack");
            // this.QueryAccount();
          }
        } else {
          this.$message.error("操作失败，" + data.message);
        }
      },
      payClosed() {
        const dom = document.getElementById('qrcode2')
        if (dom) dom.innerHTML = ''
        // this.$refs.qrCodeUrl.innerHTML = "";
        // 扫码支付弹框关闭时调用
        this.payDisable = false;
        // qrcode.clear()

        if (this.isQuery) {
          clearInterval(this.timer);
          this.isQuery = false;
          this.PayQuery();
        }
        // debugger
        this.$emit("onClosed");
      },

    },
    created() {

    }
  }

</script>

<style lang="less" scoped>
  .qrcode {
    width: 124px;
    margin: 0px auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/paydialog/paydialog.vue